/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

/**
 * Advertisement reducer
 * @param state
 * @returns {Array}
 */

function advertisement(state = global.__PRELOADED_STATE.advertisement) {
    return state;
}

export default advertisement;



// WEBPACK FOOTER //
// ./src/js/Advertisement/advertisement.reducer.js